// Função para obter URL completa da imagem
export const getImageUrl = (imgPath) => {
  if (!imgPath) return null;
  
  // Se já é uma URL completa (http/https), retornar como está
  if (imgPath.startsWith('http://') || imgPath.startsWith('https://')) {
    return imgPath;
  }
  
  // Mesmo host do site (produção no VPS) ou dev (CRA proxy → backend)
  const baseUrl =
    typeof window !== 'undefined' && window.location?.origin
      ? window.location.origin
      : 'http://localhost:5000';
  
  // Se começa com /uploads, usar diretamente
  if (imgPath.startsWith('/uploads')) {
    return `${baseUrl}${imgPath}`;
  }
  
  // Se começa com /uploads/galeria, usar diretamente
  if (imgPath.startsWith('/uploads/galeria')) {
    return `${baseUrl}${imgPath}`;
  }
  
  // Se contém "galeria" no caminho, usar pasta galeria
  if (imgPath.includes('galeria')) {
    const fileName = imgPath.replace(/.*\//, '');
    return `${baseUrl}/uploads/galeria/${fileName}`;
  }
  
  // Caso contrário, assumir que é um nome de arquivo e adicionar /uploads/
  return `${baseUrl}/uploads/${imgPath}`;
};

// Função para converter URL do YouTube para embed
export const getYouTubeEmbedUrl = (url) => {
  if (!url || !url.trim()) {
    console.warn('⚠️ URL do YouTube está vazia');
    return null;
  }
  
  // Remover espaços em branco
  url = url.trim();
  
  // Se já é uma URL de embed, retornar como está (mas garantir que tenha https)
  if (url.includes('youtube.com/embed/')) {
    if (url.startsWith('//')) {
      return `https:${url}`;
    }
    if (!url.startsWith('http')) {
      return `https://${url}`;
    }
    return url;
  }
  
  // Se contém "VIDEO_ID" literal, retornar null (placeholder inválido)
  if (url.includes('VIDEO_ID')) {
    console.warn('⚠️ URL do YouTube contém placeholder "VIDEO_ID":', url);
    return null;
  }
  
  // Extrair ID do vídeo do YouTube - múltiplos padrões
  let videoId = null;
  
  // Padrão 1: youtube.com/shorts/VIDEO_ID (YouTube Shorts)
  const matchShorts = url.match(/youtube\.com\/shorts\/([^"&?\/\s]{11})/);
  if (matchShorts && matchShorts[1]) {
    videoId = matchShorts[1];
  }
  
  // Padrão 2: youtube.com/watch?v=VIDEO_ID
  if (!videoId) {
    const match1 = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^"&?\/\s]{11})/);
    if (match1 && match1[1]) {
      videoId = match1[1];
    }
  }
  
  // Padrão 3: youtube.com/v/VIDEO_ID
  if (!videoId) {
    const match2 = url.match(/youtube\.com\/v\/([^"&?\/\s]{11})/);
    if (match2 && match2[1]) {
      videoId = match2[1];
    }
  }
  
  // Padrão 4: youtu.be/VIDEO_ID
  if (!videoId) {
    const match3 = url.match(/youtu\.be\/([^"&?\/\s]{11})/);
    if (match3 && match3[1]) {
      videoId = match3[1];
    }
  }
  
  // Padrão 5: regex genérica mais robusta (último recurso)
  if (!videoId) {
    const regExp = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
    const match = url.match(regExp);
    if (match && match[1] && match[1].length === 11) {
      videoId = match[1];
    }
  }
  
  if (videoId && videoId.length === 11) {
    return `https://www.youtube.com/embed/${videoId}`;
  }
  
  console.warn('⚠️ Não foi possível extrair ID do vídeo do YouTube da URL:', url);
  return null;
};
